import { MUTATION_TYPES } from './types';
import sessionKeys from '@/utils/constants/sessionKeys.js';

const mutations = {
  [MUTATION_TYPES.TOGGLE_SEARCH](state, value) {
    state.isSearchStudentOpenedFromOutside = false;
    if (value == undefined) {
      state.searchOpened = !state.searchOpened;
      state.showFastSearch = !state.showFastSearch;
    } else {
      state.searchOpened = value;
      state.showFastSearch = value;
    }
  },
  [MUTATION_TYPES.TOGGLE_FAST_SEARCH](state, value) {
    state.showFastSearch = value;
  },
  [MUTATION_TYPES.CLEAR_ALERTS](state) {
    state.alerts = [];
  },
  [MUTATION_TYPES.SET_IS_NAV_OPEN](state, value) {
    state.isNavOpen = value;
  },
  [MUTATION_TYPES.ADD_STUDENT_SEARCHED](state, data) {
    let historyData;

    if (Array.isArray(data)) {
      historyData = data;
    } else {
      historyData = JSON.parse(
        sessionStorage.getItem(sessionKeys.KEY_STUDENT_HISTORY)
      );
      historyData.push(data);
    }

    if (historyData.length > 0) {
      state.searchedStudentHistory = [];
      for (let studenInfoIndex in historyData) {
        let studenInfo = historyData[studenInfoIndex];
        // Verifica si el estudiante existe dentro del historial para borrarlo y
        // agregarlo como el mas reciente en el storage
        let ArrayHistory = [...state.searchedStudentHistory];
        let Exists = false;
        //Centralizada la informacion que se agrega de manera temporal a la busqueda
        let studentInformationDto = {
          studentId: studenInfo.studentId,
          fullName: studenInfo.firstName + ' ' + studenInfo.lastName,
          impediment:
            studenInfo.MipeStudent != null
              ? studenInfo.impedimentDescription
              : studenInfo.primaryImpediment,
          statusType: studenInfo.statusType,
        };

        for (let index in ArrayHistory) {
          if (
            ArrayHistory[index].studentId == studentInformationDto.studentId
          ) {
            state.searchedStudentHistory.splice(Number(index), 1);
            Exists = true;
            break;
          }
        }

        if (
          state.searchedStudentHistory.length >=
            process.env.VUE_APP_DEFAULT_PAGE_SIZE &&
          !Exists
        ) {
          state.searchedStudentHistory.splice(0, 1);
        }
        state.searchedStudentHistory.push(studenInfo);
      }

      sessionStorage.setItem(
        sessionKeys.KEY_STUDENT_HISTORY,
        JSON.stringify(state.searchedStudentHistory)
      );
    }
  },
  [MUTATION_TYPES.SELECTED_STUDENT](state, value) {
    state.selectedStudent = value;
    state.studentId = value.studentId;
    //Set in sessionStorage
    sessionStorage.setItem('selected-student', JSON.stringify(value));
  },
  [MUTATION_TYPES.SET_IS_SEARCH_STUDENT_OPENED_FROM_OUTSIDE](state, value) {
    state.isSearchStudentOpenedFromOutside = value;
  },
  [MUTATION_TYPES.SET_HIDE_HISTORY_AND_SELECT_STUDENT](state, value) {
    state.hideHistoryAndSelectAction = value;
  },
  [MUTATION_TYPES.SET_STUDENT_SEARCH_HISTORY](state, data) {
    state.studentSearchHistory = data;
  },
};

export default mutations;
